import React, { useContext, useState } from "react";
import AtomicButton from "../../atomic/button/AtomicButton";
import EatImage from "./../../global/assets/svg/eat.svg";
import "./MealPackageCard.scss";
import RadioGroup from "../../atomic/radiogroup/RadioGroup";
import { isMobile, isIpad } from "../../global/ScreenSizeHelper";
import variables from "../../global/assets/_variables.scss";
import { SignUpInfoDataContext } from "../../context-api/SignUpInfoDataProvider";
import { useNavigate } from "react-router";

let planDescription =
  "Your meal plan includes a main course, side, drink or snack, and a complimentary meal — menu items may vary";
let mealsType = "Meals";

function MealPackageCard(props) {
  const {
    data,
    options,
    currency = "$",
    setMealPlan,
    isPlanSelected,
  } = props;


  const singnUpContext = useContext(SignUpInfoDataContext);
  const navigate = useNavigate();
  const RedirectToSignup = () => navigate('/signup')


  const {
    signupAPIResponse,
    setAccountType,
    fullName,
  } = singnUpContext;
  const { errors = null } = signupAPIResponse;
  const [mealsQuantity, setMealsQuantityState] = useState(
    `${options[0].value}`
  );

  const [isLoading, setLoader] = useState(false);
  const setMealsQuantity = (e, value) => {
    if (value !== null) {
      setMealsQuantityState(value);
    }
  };
  const handleSubmit = (e) => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
      setMealPlan(data[mealsQuantity].meal_plan_id);
      setAccountType('Subscription')
      RedirectToSignup()
    }, 2000);
  };

  const styleButton = {
    backgroundColor: "#181436",
    width: "90%",
    marginTop: "15px",
    marginBottom: "15px",
    height: "40px"
  };



  const containerStyle = isMobile
    ? "meal-package-card-container meal-package-card-container-mobile"
    : "meal-package-card-container";

  const { meal_plan, price_perplate, plan_price, total_delivery_service_fees } = data[mealsQuantity];

  const OnePersonPlan = meal_plan === 'One person'
  const TwoPersonPlan = meal_plan === 'Two person'
  const FourPersonPlan = meal_plan === 'Four person'

  return (
    <div className={`${containerStyle} ${isIpad ? "meal-package-card-container-ipad" : ""}`}>
      {/* <img className="eat_img" src={EatImage} /> */}
      <div className="content">
        <h4 className={OnePersonPlan && "plan-title-one" || TwoPersonPlan && "plan-title-two" || FourPersonPlan && "plan-title-four"}>{`${meal_plan} plan`}</h4>
        <p className="plan-description">{planDescription}</p>
        <div className="radio-section">
          <RadioGroup
            options={options}
            handleChange={setMealsQuantity}
            value={mealsQuantity}
          />
          <span className="meals">{mealsType}</span>
        </div>
        <div className="price-section-container">
          <div className={"price-section-left"}>
            <div className="price-label">{`${currency} ${price_perplate}`}</div>
            <div className="price-desc">Per Meal</div>
          </div>
          <div className={"price-section-right"}>
            <div className="price-label">{`${currency} ${plan_price}`}</div>
            <div className="price-desc">Total</div>
          </div>
        </div>
      </div>

      <div style={{ fontSize: '12px', marginTop: '12px', fontFamily: 'Inter Regular', color: 'gray' }}>
        {`Delivery & service fee of $${total_delivery_service_fees} included`}
      </div>
      <AtomicButton
        id="meal-plan-submit-button"
        label={isPlanSelected ? "Selected Package" : "Select Package"}
        handleSubmit={handleSubmit}
        style={isPlanSelected ? styleButton : { ...styleButton, backgroundColor: '#1B1642' }}
        // disabled={isPlanSelected}
        loadingButtonStyle={{
          ...styleButton,
          backgroundColor: "#181436",
        }}
        loading={isLoading}
      />
    </div>
  );
}

export default MealPackageCard;
